



















import { Prop, Component, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class Checkbox extends Vue {
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly error!: boolean;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ required: true }) readonly value!: boolean | null;
  @Prop({ default: true }) readonly trueValue!: any;
  @Prop({ default: false }) readonly falseValue!: any;
  @Prop({ default: false }) readonly circular!: boolean

  internalValue: boolean | null = this.value;

  get computedValue () {
    return this.internalValue
  }

  set computedValue (value) {
    this.internalValue = value
    this.$emit('input', value)
  }

  get classes () {
    let classes = ''
    if (this.disabled) {
      classes += ' is-disabled'
    }
    if (this.required) {
      classes += ' is-required'
    }
    if (this.error) {
      classes += ' is-error'
    }
    switch (this.value) {
      case null:
        classes += ' indeterminate'
        break
      case false:
        classes += ' unchecked'
        break
      case true:
        classes += ' checked'
        break
      default:
        throw new Error('Invalid checkbox state')
    }

    return classes.trim()
  }

  @Watch('value')
  valueUpdated (newValue: boolean, oldValue: boolean) {
    this.internalValue = newValue
  }
}
